import { render, staticRenderFns } from "./wageJobTitle.vue?vue&type=template&id=2064e264&"
import script from "./wageJobTitle.vue?vue&type=script&lang=js&"
export * from "./wageJobTitle.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../yiweb/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports